import { __extends } from "tslib";
import { NodeMaterialBlock } from "../nodeMaterialBlock.js";
import { NodeMaterialBlockConnectionPointTypes } from "../Enums/nodeMaterialBlockConnectionPointTypes.js";
import { NodeMaterialBlockTargets } from "../Enums/nodeMaterialBlockTargets.js";
import { RegisterClass } from "../../../Misc/typeStore.js";
/**
 * Block used to expand a Color3/4 into 4 outputs (one for each component)
 */
var ColorSplitterBlock = /** @class */ (function (_super) {
    __extends(ColorSplitterBlock, _super);
    /**
     * Create a new ColorSplitterBlock
     * @param name defines the block name
     */
    function ColorSplitterBlock(name) {
        var _this = _super.call(this, name, NodeMaterialBlockTargets.Neutral) || this;
        _this.registerInput("rgba", NodeMaterialBlockConnectionPointTypes.Color4, true);
        _this.registerInput("rgb ", NodeMaterialBlockConnectionPointTypes.Color3, true);
        _this.registerOutput("rgb", NodeMaterialBlockConnectionPointTypes.Color3);
        _this.registerOutput("r", NodeMaterialBlockConnectionPointTypes.Float);
        _this.registerOutput("g", NodeMaterialBlockConnectionPointTypes.Float);
        _this.registerOutput("b", NodeMaterialBlockConnectionPointTypes.Float);
        _this.registerOutput("a", NodeMaterialBlockConnectionPointTypes.Float);
        _this.inputsAreExclusive = true;
        return _this;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */
    ColorSplitterBlock.prototype.getClassName = function () {
        return "ColorSplitterBlock";
    };
    Object.defineProperty(ColorSplitterBlock.prototype, "rgba", {
        /**
         * Gets the rgba component (input)
         */
        get: function () {
            return this._inputs[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorSplitterBlock.prototype, "rgbIn", {
        /**
         * Gets the rgb component (input)
         */
        get: function () {
            return this._inputs[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorSplitterBlock.prototype, "rgbOut", {
        /**
         * Gets the rgb component (output)
         */
        get: function () {
            return this._outputs[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorSplitterBlock.prototype, "r", {
        /**
         * Gets the r component (output)
         */
        get: function () {
            return this._outputs[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorSplitterBlock.prototype, "g", {
        /**
         * Gets the g component (output)
         */
        get: function () {
            return this._outputs[2];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorSplitterBlock.prototype, "b", {
        /**
         * Gets the b component (output)
         */
        get: function () {
            return this._outputs[3];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorSplitterBlock.prototype, "a", {
        /**
         * Gets the a component (output)
         */
        get: function () {
            return this._outputs[4];
        },
        enumerable: false,
        configurable: true
    });
    ColorSplitterBlock.prototype._inputRename = function (name) {
        if (name === "rgb ") {
            return "rgbIn";
        }
        return name;
    };
    ColorSplitterBlock.prototype._outputRename = function (name) {
        if (name === "rgb") {
            return "rgbOut";
        }
        return name;
    };
    ColorSplitterBlock.prototype._buildBlock = function (state) {
        _super.prototype._buildBlock.call(this, state);
        var input = this.rgba.isConnected ? this.rgba : this.rgbIn;
        if (!input.isConnected) {
            return;
        }
        var rgbOutput = this._outputs[0];
        var rOutput = this._outputs[1];
        var gOutput = this._outputs[2];
        var bOutput = this._outputs[3];
        var aOutput = this._outputs[4];
        if (rgbOutput.hasEndpoints) {
            state.compilationString += this._declareOutput(rgbOutput, state) + " = ".concat(input.associatedVariableName, ".rgb;\r\n");
        }
        if (rOutput.hasEndpoints) {
            state.compilationString += this._declareOutput(rOutput, state) + " = ".concat(input.associatedVariableName, ".r;\r\n");
        }
        if (gOutput.hasEndpoints) {
            state.compilationString += this._declareOutput(gOutput, state) + " = ".concat(input.associatedVariableName, ".g;\r\n");
        }
        if (bOutput.hasEndpoints) {
            state.compilationString += this._declareOutput(bOutput, state) + " = ".concat(input.associatedVariableName, ".b;\r\n");
        }
        if (aOutput.hasEndpoints) {
            state.compilationString += this._declareOutput(aOutput, state) + " = ".concat(input.associatedVariableName, ".a;\r\n");
        }
        return this;
    };
    return ColorSplitterBlock;
}(NodeMaterialBlock));
export { ColorSplitterBlock };
RegisterClass("BABYLON.ColorSplitterBlock", ColorSplitterBlock);
//# sourceMappingURL=colorSplitterBlock.js.map